import React from "react";
import "./collaborators.css";
import { ReactSelect } from "@anchor/react-components/dist/lib/components";
import { McTag } from "@maersk-global/mds-react-wrapper/components-core";
import { HandleCollaborators } from ".";

function Collaborators({
  postmortemCollaborators,
  setPostmortemCollaborators,
  compact,
}) {
  const {
    handleAddCollaborator,
    handleRemoveCollaborator,
    collaborators,
    errMessage,
    fetchingProfiles,
    getUserProfiles,
    profiles,
  } = HandleCollaborators(postmortemCollaborators, setPostmortemCollaborators);

  return (
    <div className={`collaborators-root seventh-step${compact ? " collaborators-root--compact" : ""}`}>
      {!compact && (
        <p className="collaborators-heading">Active Collaborators</p>
      )}

      <div style={compact ? { width: "200px", flexShrink: 0 } : { width: "100%" }}>
        <ReactSelect
          isSearchable
          className="react-select"
          closeMenuOnSelect
          customNoOptionsMessage={<p>Not a valid option</p>}
          errorMessage={errMessage}
          fit={compact ? "small" : "medium"}
          hint=""
          hintPosition="left"
          id="selectCollaborator"
          isClearable
          label={compact ? "" : "Add collaborator"}
          name="selectCollaborator"
          onChange={handleAddCollaborator}
          onInputChange={getUserProfiles}
          onMenuClose={function noRefCheck() {}}
          onMenuOpen={function noRefCheck() {}}
          onOptionUpdate={function noRefCheck() {}}
          isLoading={fetchingProfiles}
          noOptionsMessage={() => "Search by name or email"}
          options={profiles ? profiles : []}
          orientation="vertical"
          placeholder={compact ? "Add collaborator…" : "Search by name or email"}
          required
          suggestType="static"
          value={[]}
          variant="default"
          width={compact ? 160 : 100}
          defaultInputValue=""
          error={!!errMessage}
        />
      </div>

      {collaborators && collaborators.length > 0 && (
        <div className="collaborators-chips">
          {collaborators.map(
            (collaborator, indx) =>
              collaborator.status && collaborator.email && (
                <McTag
                  key={indx}
                  label={collaborator.name || collaborator.email}
                  fit="small"
                  appearance="neutral-weak"
                  withaction
                  dismiss={() => handleRemoveCollaborator(collaborator.email)}
                />
              )
          )}
        </div>
      )}
    </div>
  );
}

export default Collaborators;
